<template>
  <div v-if="isStatsValid" class="process-stats">
    <div class="process-stats__head">
      <div class="d-flex justify-content-between">
        <div>
          <div class="d-flex align-items-center">
            <CIcon name="cipLoading01" size="custom" :height="17" class="mr-2"/>
            <h6>
              <translate translate-context="upload.stats">Photo processing...</translate>
            </h6>
          </div>
          <div class="subtitle">
            <translate translate-context="upload.stats">Available soon</translate>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center">
      <CSpinner v-if="loading" size="sm" color="primary" class="mx-auto position-absolute"/>
      <div class="d-flex align-items-center w-100" :class="{'invisible': loading}">
        <ProgressBars :percentages="barsPercentages"/>
      </div>
    </div>
    <div class="process-stats__footer">
      <div>
        <span class="font-weight-semi-bold">{{ processed}}</span>/{{ uploaded }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProgressBars from "@/domain/events/components/ProgressBars.vue";

export default {
  name: "ProcessStats",
  components: {ProgressBars},
  data() {
    return {
      loading: false
    }
  },
  async mounted() {
    await this.setPicaServiceId(this.$route.params.picaServiceId)
    await this.loadStats()
  },
  computed: {
    ...mapGetters('uploader', [
      'stats',
      'picaServiceId'
    ]),
    isStatsValid() {
      if (!this.stats) return false
      if (this.stats.upload_limit > 0) return false // there is no limit on the upload front
      if (this.stats.uploaded <= 0) return false
      if (this.in_processing <= 0) return false // at least a photo is in processing
      return true
    },
    processed() {
      return this.stats.processed
    },
    uploaded() {
      return this.stats.uploaded
    },
    in_processing() {
      return this.uploaded - this.processed
    },
    barsPercentages() {
      return [
        (this.processed / this.uploaded) * 100,
      ]
    }

  },
  methods: {
    ...mapActions('uploader', [
      'fetchStats',
      'setPicaServiceId'
    ]),

    async loadStats(delay = 0, showLoading = true) {
      if(showLoading){
        this.loading = true
        await this.delay(delay)
      }
      await this.fetchStats()
      this.loading = false
    }
  }
}
</script>